import React from 'react';
import Alert, { AlertTypes } from 'DesignSystem/Notifications/Alert';
import Note from './Note';

const AlertNote = props => (
  <Alert
    text=""
    type={AlertTypes.Warning}
  >
    <Note {...props} includeDefaultNoteStyle={false} />
  </Alert>
);

export default AlertNote;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/AlertNote.jsx